<template>
  <main class="contenedor contenido-principal sombra">
    <h2><span>Conoce más</span>sobre nosotros</h2>
    <div class="contenido-nosotros">
      <div class="imagen">
        <picture>
          <source scrset="../../assets/img/nosotros_sidebar.avif" type="image/avif">
          <source scrset="../../assets/img/nosotros_sidebar.webp" type="image/webp">
          <source scrset="../../assets/img/nosotros_sidebar.jpg" type="image/jpeg">
          <img loading="lazy" decoding="async" src="../../assets/img/nosotros_sidebar.jpg" lazyalt="Imagen" width="500" height="300" />
        </picture>
      </div>
      <div class="texto">
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Odit eum illum sed doloribus harum incidunt, pariatur, suscipit aspernatur, quia error nostrum? Iste laudantium sint, nihil itaque enim laborum deleniti repellendus.</p>
        <blockquote>¡Atención a los detalles!</blockquote>
        <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Debitis quis molestias nesciunt adipisci, non odio tempora iusto? Doloribus deserunt nemo eius nulla necessitatibus excepturi numquam quam. Accusamus temporibus laboriosam fugiat.</p>
      </div>
    </div>
  </main>
</template>

<style scoped>
@media (min-width: 768px) {
  .contenido-nosotros {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 5rem;
  }
}
.contenido-nosotros .imagen {
  margin-bottom: 5rem;
  background-color: #fff;
}
@media (min-width: 768px) {
  .contenido-nosotros .imagen {
    margin-right: 2rem;
    margin-bottom: 0;
  }
}
.contenido-nosotros .imagen img {
  padding: 2.5rem;
  transform: rotate(-4deg);
  box-shadow: 2px 2px 8px #000;
}
.contenido-nosotros .texto blockquote {
  margin: 0 0 0 5rem;
  padding: 1rem;
  border-left: 0.5rem solid #5e311e;
  font-size: 2rem;
}
</style>